/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiMenuDots3VIcon16Light } from './UiMenuDots3VIcon16Light';
import { UiMenuDots3VIcon16Regular } from './UiMenuDots3VIcon16Regular';
import { UiMenuDots3VIcon16Solid } from './UiMenuDots3VIcon16Solid';
import { UiMenuDots3VIcon20Light } from './UiMenuDots3VIcon20Light';
import { UiMenuDots3VIcon20Regular } from './UiMenuDots3VIcon20Regular';
import { UiMenuDots3VIcon20Solid } from './UiMenuDots3VIcon20Solid';
import { UiMenuDots3VIcon24Regular } from './UiMenuDots3VIcon24Regular';
import { UiMenuDots3VIcon24Solid } from './UiMenuDots3VIcon24Solid';
import { UiMenuDots3VIcon32Regular } from './UiMenuDots3VIcon32Regular';
import { UiMenuDots3VIcon64Regular } from './UiMenuDots3VIcon64Regular';
var sizes = {
    16: {
        light: UiMenuDots3VIcon16Light,
        regular: UiMenuDots3VIcon16Regular,
        solid: UiMenuDots3VIcon16Solid,
    },
    20: {
        light: UiMenuDots3VIcon20Light,
        regular: UiMenuDots3VIcon20Regular,
        solid: UiMenuDots3VIcon20Solid,
    },
    24: {
        regular: UiMenuDots3VIcon24Regular,
        solid: UiMenuDots3VIcon24Solid,
    },
    32: {
        regular: UiMenuDots3VIcon32Regular,
    },
    64: {
        regular: UiMenuDots3VIcon64Regular,
    },
};
export var UiMenuDots3VIcon = forwardRef('UiMenuDots3VIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
